import { render, staticRenderFns } from "./CourseGroupBox.vue?vue&type=template&id=2593655b&scoped=true"
import script from "./CourseGroupBox.vue?vue&type=script&lang=js"
export * from "./CourseGroupBox.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupBox.vue?vue&type=style&index=0&id=2593655b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593655b",
  null
  
)

export default component.exports